import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { GasEmissionUnit } from '@Router/EsgGreenhouse/Components/GasEmissionMessage';

import { formatYear } from '@Utils/datetime';
import { formatNumberWithDigit } from '@Utils/number';

const NetZeroTargetCell = (fields: GridRenderCellParams) => {
  const { value } = fields;
  const formatYearTh = value.year ? formatYear(value.year, 'th-TH') : undefined;
  const formatYearEn = value.year ? formatYear(value.year, 'en-EN') : undefined;
  const formatQuantity = value.gasEmissionQuantity
    ? formatNumberWithDigit(value.gasEmissionQuantity)
    : undefined;

  if (!value.year) {
    if (value.gasEmissionPercent && !value.gasEmissionQuantity) {
      return (
        <Box>
          <Typography>ลด {value.gasEmissionPercent}% เทียบกับปีฐาน</Typography>
          <Typography mt={2}>
            Reduced by {value.gasEmissionPercent}% in compared to the base year
          </Typography>
        </Box>
      );
    } else if (!value.gasEmissionPercent && value.gasEmissionQuantity) {
      return (
        <Box>
          <Typography>
            ลด {formatQuantity} <GasEmissionUnit /> เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            Reduced by {formatQuantity} <GasEmissionUnit /> in compared to the
            base year
          </Typography>
        </Box>
      );
    } else if (value.gasEmissionPercent && value.gasEmissionQuantity) {
      return (
        <Box>
          <Typography>
            ลด {value.gasEmissionPercent}% หรือ {formatQuantity}
            <GasEmissionUnit /> เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            Reduced by {value.gasEmissionPercent}% or {formatQuantity} tCO
            <GasEmissionUnit /> in compared to the base year
          </Typography>
        </Box>
      );
    }
    return <Typography>-</Typography>;
  }

  if (value.year) {
    if (!value.gasEmissionPercent && !value.gasEmissionQuantity) {
      return (
        <Box>
          <Typography>{formatYearTh}</Typography>
          <Typography mt={2}>{formatYearEn}</Typography>
        </Box>
      );
    } else if (value.gasEmissionPercent && !value.gasEmissionQuantity) {
      return (
        <Box>
          <Typography>
            {formatYearTh}: ลด {value.gasEmissionPercent}% เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            {formatYearEn}: Reduced by {value.gasEmissionPercent}% in compared
            to the base year
          </Typography>
        </Box>
      );
    } else if (!value.gasEmissionPercent && value.gasEmissionQuantity) {
      return (
        <Box>
          <Typography>
            {formatYearTh}: ลด {formatQuantity} <GasEmissionUnit />
            เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            {formatYearEn}: Reduced by {formatQuantity} <GasEmissionUnit /> in
            compared to the base year
          </Typography>
        </Box>
      );
    } else if (value.gasEmissionPercent && value.gasEmissionQuantity) {
      return (
        <Box>
          <Typography>
            {formatYearTh}: ลด {value.gasEmissionPercent}% หรือ {formatQuantity}{' '}
            <GasEmissionUnit /> เทียบกับปีฐาน
          </Typography>
          <Typography mt={2}>
            {formatYearEn}: Reduced by {value.gasEmissionPercent}% or{' '}
            {formatQuantity} <GasEmissionUnit /> in compared to the base year
          </Typography>
        </Box>
      );
    }
  }
};

export default NetZeroTargetCell;
